/**
 * Created by esenckewitch on 19.03.2026.
 */

const OKBridgePlatform = function () {
    VKPlatform.call(this, connector.OKBRIDGE);
};

OKBridgePlatform.prototype = Object.create(VKPlatform.prototype);
OKBridgePlatform.prototype.constructor = OKBridgePlatform;

OKBridgePlatform.prototype._canCreateShortcut = function () {
    return false;
};
